<template>
  <div>
    <question
        v-if="!finished"
        :content="quizData.questions[currentQuestion]"
        @goToNext="goToNext"
    ></question>
    <div v-else class="final-screen">
      <div class="final-text" v-html="quizData.finalScreen.html"></div>
      <div class="final-footer" v-html="quizData.finalScreen.footerHtml"></div>
    </div>
  </div>
</template>

<script>
import Question from './components/Question.vue'
import theData from './nagbp.json'

export default {
  name: 'App',
  data: () => ({
    quizData: theData,
    currentQuestion: 1,
  }),
  components: {
    Question
  },
  methods: {
    goToNext() {
      this.currentQuestion ++
    }
  },
  computed: {
    finished() {
      return !this.quizData || !this.quizData.questions.hasOwnProperty(this.currentQuestion)
    }
  }
}
</script>

<style lang="scss">

#esse-psoriaz {
  --yellow: #F9B62B;
  --yellow-d-10:  #EAA007;
  --yellow-d-15:  #D28F06;
  --yellow-d-20:  #B97E05;
  --yellow-d-25:  #A06D05;
  --yellow-d-30:  #875C04;
  --yellow-l-10:  #FAC75D;
  --yellow-l-15:  #FBD075;
  --yellow-l-20:  #FCD88E;
  --yellow-l-25:  #FDE1A7;
  --yellow-l-30:  #FDE9C0;
  --brown:  #842C19;
  --brown-d-10:  #591E11;
  --brown-d-15:  #44170D;
  --brown-d-20:  #2E0F09;
  --brown-d-25:  #190805;
  --brown-l-10:  #AF3A21;
  --brown-l-15:  #C44125;
  --brown-l-20:  #D74A2C;
  --brown-l-25:  #DB5D41;
  --brown-l-30:  #DF6F57;
  --brown2: #632340;
  --ginger: #CC6910;

  font-family: Verdana, Helvetica, Arial, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--brown);
  div, p, span, i {
    box-sizing: border-box;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .4s ease
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0
  }

  background-color: #fff;
  .weight-bold {
    font-weight: 700;
  }
  .question {
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    padding: 20px;
    .q-text {
      font-size: 1.8rem;
      font-weight: 700;
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 1rem;
    }
    .q-img-wraper {
      text-align: center;
      img {
        max-width: 90%;
      }
    }
    .q-invite-text {
      text-align: center;
      font-size: 1.25rem;
      font-weight: 400;
      margin-bottom: 10px;
      margin-top: 10px;
      height: 3rem;
      display: inline-block;
      width: 100%;
      line-height: 1.5rem;
    }
    .answers-list-block {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: nowrap;
      padding-bottom: 60px;
      .answer-btn {
        border: none;
        outline: none;
        flex: 1;
        display: flex;
        justify-content: center;
        flex-direction: column;
        flex-wrap: nowrap;
        padding: 10px;
        text-align: center;
        background-color: inherit;

        opacity: 0;
        transform: translateY(-70px);
        &:visited, &:active {
          border: none;
          outline: none;
        }
        &:hover {
          cursor: pointer;
          .answer-icon i {
            background-color: var(--ginger);
          }
          .answer-text {
            color: var(--brown-d-20);
          }
        }
        >span {
          display: block;
          width: 100%;
        }
        .answer-icon {
          i{
            display: inline-block;
            width: 30px;
            height: 30px;
            background-color: var(--yellow);
            transition: background-color 0.7s ease;
            border-radius: 50%;
          }
        }
        .answer-text {
          padding-top: 10px;
          flex: 1;
          color: var(--brown);
          font-weight: 400;
          font-size: 1rem;
          transition: color 0.7s ease;
        }
      }
    }
    .sources-list {
      font-size: 0.63rem;
      font-weight: 400;
      text-align: justify;
      line-height: 0.8rem;
      color: black;
      opacity: 0;
      transform: translateY(70px);
      >p{
        margin: 0px 0px 5px 0px;
      }
      >p>a {
        color: var(--brown);
        text-decoration: none;
      }
    }
    .answer-result {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      >div, >h4 {
        flex: 1;
      }
      h4 {
        text-align: center;
        font-size: 1.25rem;
        font-weight: 400;
        margin-bottom: 2rem;
      }
      .answer-text {
        text-align: center;
        font-size: 1.8rem;
        font-weight: 400;
        text-transform: uppercase;

      }
      .next-btn-wrapper {
        text-align: center;
        padding: 40px 0px;
        .next-btn {
          display: inline-block;
          background-color: var(--yellow);
          color: var(--brown);
          text-align: center;
          font-size: 1.25rem;
          font-weight: 400;
          width: 16rem;
          height: 3.43rem;
          line-height: 3.43rem;
          border-radius: 5px;
          transition: background-color 0.7s ease, color 0.7s ease;
          opacity: 0;
          transform: translateY(-70px);
          &:hover {
            cursor: pointer;
            background-color: var(--brown);
            color: var(--yellow);
          }
        }
      }
      .answer-img-wrapper {
        text-align: center;
        padding: 10px 0px 50px 0px;
        img {
          max-width: 90%;
        }
      }
    }
  }
  .final-screen {
    text-align: center;
    font-size: 1.81rem;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--ginger);
    .final-text{
      padding: 10rem 0;
      >span {
        color: var(--brown);
      }
    }
    .final-footer {
      font-size: 0.63rem;
      font-weight: 400;
      color: black;
      text-align: center;
      padding: 3rem 0;
      line-height: 1rem;
      a {
        text-decoration: none;
        color: var(--brown);
      }
    }
  }
}

@media only screen and (min-width: 300px) and (max-width: 500px) {
  #esse-psoriaz {
    .question {
      .q-text {
        font-size: 1.3rem;
      }
      .answer-result {
        .answer-text {
          font-size: 1.3rem;
        }
      }
      .answers-list-block {
        flex-direction: column;
        .answer-btn {
          background: rgba(0,0,0,0.15);
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
